
export default {
  name: "MyHome",
};
